/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Light Icon component.
 */
export const LightIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M12.0038 4.36744L11.9965 1M12.0038 22.9999L11.9965 19.6325M4.36747 11.9965L1 12.0038M23 11.9974L19.6325 12.0047M6.84552 17.6309L4.58032 20.1189M19.4198 3.88072L17.1546 6.36875M6.53742 6.66625L4.12198 4.32116M19.8775 19.6787L17.4621 17.3337M16.8807 11.9993C16.8807 14.6953 14.6951 16.8809 11.999 16.8809C9.3029 16.8809 7.11729 14.6953 7.11729 11.9993C7.11729 9.30329 9.3029 7.11773 11.999 7.11773C14.6951 7.11773 16.8807 9.30329 16.8807 11.9993Z' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap='round' />
    </svg>
  );
};

export default LightIcon;
